import * as Role from '../constants/role';
import * as Status from '../constants/status';

export function podeChamarPatchAuditoria(role) {
  if (!role) return false;
  return role === Role.SUPER_ADMIN || role === Role.ADMIN || role === Role.AUDITORIA_NSIR;
}

export function situacaoPermiteEdicaoAuditoria(nsirStatus) {
  if (!nsirStatus) return false;
  return nsirStatus === Status.DIGITACAO_FINALIZADA || nsirStatus === Status.EXECUTADA_GDIS;
}

export function isRoleAuditoriaNsir(role) {
  return role === Role.AUDITORIA_NSIR;
}

export function podePersistirAuditoria({ role, nsirStatus, modoEdicaoAuditoria }) {
  if (!situacaoPermiteEdicaoAuditoria(nsirStatus)) return false;
  if (!podeChamarPatchAuditoria(role)) return false;
  if (isRoleAuditoriaNsir(role) && !modoEdicaoAuditoria) return false;
  return true;
}
